module.exports = __webpack_public_path__ + "img/47-r.87a12593.png";